export function toRootDomain(domain: string): string {
  const parts = domain.split(".").slice(-2);
  return parts.join(".");
}
